<template>
  <div class="students-list-scroll-area">
    <div class="flex p-4">
      <vs-input icon="icon-search" icon-no-border icon-pack="feather" style="height: 44px" class="w-full input-rounded-full" placeholder="بحث..." v-model="searchQuery"/>
      <feather-icon class="md:inline-flex lg:hidden ml-2 cursor-pointer" icon="XIcon" @click="$emit('closeSidebar', false)" />
    </div>
    <vs-divider class="d-theme-border-grey-light m-0" />
    <div class="flex pl-2 pr-4 my-5 justify-between items-center">
      <h3 class="text-primary">نتائج الواجب</h3>
      <div class="flex flex-col items-end">
        <span>الوقت</span>
        <span>الدرجة</span>
      </div>
    </div>
    <VuePerfectScrollbar class="students-list-scroll-area" :settings="settings">
      <ul class="bordered-items">
        <li class="cursor-pointer" v-for="(student, index) in students" :key="student.id" @click="selected(student)">
          <div class="flex items-center hover:bg-hover px-2 py-3" :class="{'bg-primary-gradient text-white shadow-lg': isSelected(index)}">
            <div class="mr-1">
              <vs-avatar class="border-2 border-solid border-white" :src="student.image" size="42px"></vs-avatar>
            </div>
            <div class="w-full flex items-center justify-between overflow-hidden">
              <div class="flex flex-col truncate w-4/6">
                <h5 class="font-bold truncate" :class="{'text-white': isSelected(index)}">{{ student.full_name }}</h5>
                <span class="truncate">{{ student.id }} ( {{student.course_group}} )</span>
              </div>
              <div class="flex self-start flex-col items-end w-2/6">
                <template v-if="!student.answer">
                  <span class="text-danger" :class="{'text-white': isSelected(index)}">لم يتم التسليم</span>
                  <span>{{assignmentMark}}/*</span>
                </template>
                <template v-else>
                  <span class="truncate">{{student.answer.submit_date | date}}, {{student.answer.submit_date | time}}</span>
                  <span dir="ltr">{{student.answer.mark !== null ? student.answer.mark : '*'}}/{{assignmentMark}}</span>
                </template>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        name: 'AssignmentCorrectionStudents',
        components: { VuePerfectScrollbar },
        props: {
            students: {
                type: Array,
                required: true
            },
            selectedStudent: {
                type: Object,
                default: null,
            },
            assignmentMark: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                settings: {
                    maxScrollbarLength: 80,
                    wheelPropagation: true,
                },
                searchQuery: '',
            }
        },
        computed: {
            studentsWithGroups(){
                return this.students.map(group => {
                    return Object.assign({}, group, {students: group.students.filter(student => {
                            return student.full_name.indexOf(this.searchQuery) !== -1
                        })
                    })
                })
            }
        },
        methods: {
            isSelected(index){
                return index === this.students.indexOf(this.selectedStudent)
            },
            selected(student){
                this.$emit('selected', student)
            },
        },
    }
</script>
